import { createThunkRoutine } from 'redux-thunk-routine';
import { FETCH_DEFAULT_PRODUCT_SETTINGS } from './action-types';

export const FetchDefaultProductSettingsRoutine = createThunkRoutine(FETCH_DEFAULT_PRODUCT_SETTINGS);
